import { render } from "./MenuItemSelector.vue?vue&type=template&id=576bb57c"
import script from "./MenuItemSelector.vue?vue&type=script&lang=js"
export * from "./MenuItemSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__